import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { Event } from "@circle-react/types";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { MobileEventsModalHeader } from "../../MobileEventsHeader";
import { Actions } from "./Actions";
import { Sections } from "./Sections";
import { Title } from "./Title";

interface EventsHeaderProps {
  event: Event | null;
  handleClose: () => void;
  isCreating: boolean;
  isEditMode: boolean;
  isOpen?: boolean;
  onPublish: (editMode: any) => void;
  validateAndSetCurrentSection: (
    sectionKey: string,
    setCurrentSection: (sectionKey: string) => void,
  ) => void;
}

export const EventsHeader = ({
  isOpen,
  isEditMode,
  isCreating,
  event,
  onPublish,
  validateAndSetCurrentSection,
  handleClose,
}: EventsHeaderProps) => {
  const actionsProps = {
    event,
    isEditMode,
    onPublish,
  };
  const isSmScreen = useSmScreenMediaQuery();

  if (isSmScreen) {
    return (
      <MobileEventsModalHeader
        isOpen={isOpen}
        isEditMode={isEditMode}
        handleClose={handleClose}
      />
    );
  }

  return (
    <FullScreenModal.HeaderContent>
      <Title
        event={event}
        isCreating={isCreating}
        isEditMode={isEditMode}
        actionsProps={actionsProps}
      />
      {isEditMode && (
        <>
          <FullScreenModal.HeaderContent.Navigation>
            <Sections onChangeSection={validateAndSetCurrentSection} />
          </FullScreenModal.HeaderContent.Navigation>
          <Actions {...actionsProps} className="hidden lg:flex" />
        </>
      )}
    </FullScreenModal.HeaderContent>
  );
};
